import React, { useEffect, useRef, useState } from 'react'
import { useIsDesktop } from '../../hooks';
import Copy from '../Copy/Copy';
import Button from '../Elements/Button';
import { Spinner } from '../Elements/Spinner/Spinner';
import { v4 as uuidv4 } from 'uuid';
import './Table.scss';
import config from '../../config/config';

const Table = ({isLoading, data, headers, types}) => {
    const isDesktop = useIsDesktop();
    return (
        <div className="table-component">
            <div className="table-component__container">
                {isLoading ? <Spinner /> : data?.length === 0 ? <div className="search-box-empty-container">
                    <img src={require('../../images/empty-search.svg').default} alt="empty search" />
                    <span>Nothing found, search again.</span>
                </div> : <div className="table-component__container--rows">
                    {headers && isDesktop && <div className="table-component__container--rows-tr th">
                        <Td type="id" />
                        {Object.values(headers)?.map(td => <Td key={td} content={td} />)}
                    </div> }
                        
                    {data.map((rowData, index) => <div key={index} className="table-component__container--rows-tr"> 
                        {isDesktop ? <> 
                            <Td key={index} content={index+1} type="id" />
                            {Object.values(rowData)?.map((td, index) => <Td key={td} type={types?.[index]} content={td} />)}
                        </> : <MobileRow key={uuidv4()} headers={headers} index={index} rowData={rowData} types={types} />}
                    </div>)}
                </div>}    
            </div>
        </div>
    )
}

const MobileRow = ({index, rowData, types, headers}) => {
    const [isOpen, setIsOpen] = useState();
    const optionsRowData = Object.values(rowData).slice(1, Object.keys(rowData).length);
    const firstTd = Object.values(rowData)?.[0];

    const onClick = () => {
        setIsOpen(!isOpen);
    }

    return <div className={`mobile-row-component ${isOpen ? 'is-open' : ''}`}> 
        <div className="mobile-row-component__container">
            <Td content={index+1} type="id" />
            <Td content={firstTd} title={isOpen && headers?.[0]} type={isOpen && types?.[0]} />
            <div className="view-icon-td">
                <Button className="view-icon-button" onClick={onClick}><img src={require(`../../images/icons/view-icon${isOpen ? '-open' : ''}.svg`).default} alt="view icon" /></Button>
            </div>
        </div>

        {isOpen && <div className="mobile-row-component__options">
            {optionsRowData.map((row, index) => <Td type={types?.[index+1]} title={headers?.[index+1]} content={row} />)}
        </div> }
    </div>
}

const Td = ({content, type, title}) => {
    const copiedRef = useRef();
    const [isOnCopy, setIsOnCopy] = useState();

    useEffect(() => {
        return () => {
            if(copiedRef.current) clearTimeout(copiedRef.current);
        }
    }, [])

    const renderView = (config) => {
        switch(type) {
            case 'copy':
                const onCopied = () => {
                    setIsOnCopy(true);
                    copiedRef.current = setTimeout(() => {
                        setIsOnCopy(false);
                    }, 2000);
                }

                return <> 
                    <Content title={title} content={content} isOnCopy={isOnCopy} />
                    <Copy text={content} onCopied={onCopied} />
                </>;
            case 'nft-type':
                const nftImage = (path) => {
                    if(config.nftsPath[path.toLowerCase()]) return <img src={require(`../../images/nfts/${config.nftsPath[path.toLowerCase()]}`).default} alt="nft" />
                    return null;
                } 

                return <> 
                    <Content title={title} content={config.nftsLabels?.[content?.toLowerCase()] ?? content} />
                    {nftImage(content.toLowerCase())}
                </>
            default:
                return <Content title={title} content={content} />
        }
    }

    return <div className={`table-td-component ${type ?? ''}`}>
        <div className={`table-td-component__container ${type ?? ''} ${isOnCopy ? 'copied' : ''}`}>
            {renderView(config)}
        </div>
    </div>
}

const Content = ({title, content, isOnCopy}) => {
    return (
        <span className="content-component">  
            {title && <div>{title}</div>}
            {isOnCopy ? <>Copied to clipboard!</> : content}
        </span>
    )
}

export default Table;
  